/**
 * Game-related translations for Chinese (Simplified) language
 * This file contains translations for game mechanics, stages, and end reasons
 */
export default {
  game: {
    winner: '胜利方',
    evil: '坏人方',
    good: '好人方',
    stage: '阶段',
    voteStage: '投票阶段',
    voting: '投票',
    excalibur: '神剑',
    'team building': '团队建立',
    mission: '任务',
    initialization: '初始化',
    'lady of lake': '湖中验人',
    'check loyalty': '检查忠诚度',
    'witch loyalty': '女巫的忠诚',
    'announce loyalty': '宣布忠诚',
    'give card': '给卡',
    'lead to victory': '引领胜利',
    'restore honor': '恢复荣誉',
    'king returns': '王者归来',
    'play card': '打出卡牌',
    'reveal loyalty': '揭示忠诚',
    'we found you': '我们找到你了',
    ambush: '埋伏',
    witch: '巫婆',
    end: '完结',
    lancelots: '兰斯洛特',
    assassinate: '暗杀',
    hidden: '隐藏',
    historyMode: '记录阶段',
    gameIsEnded: '游戏结束',
    rolesAndAddons: '角色与插件',
  },
  endReason: {
    manualy: '游戏已手动完成',
    evilTeamMissions: '坏人方3次任务失败',
    goodTeamMissions: '好人方3次任务成功',
    missMerlin: '坏人方暗杀梅林失败',
    missGuinevere: '坏人方暗杀女皇失败',
    missLovers: '坏人方暗杀恋人失败',
    missCleric: '邪恶团队尝试杀死牧师 + 1 但失败了',
    killCleric: '邪恶团队杀死了牧师 + 1',
    killGuinevere: '坏人方暗杀女皇成功',
    killLovers: '坏人方暗杀恋人成功',
    killMerlin: '坏人方暗杀梅林成功',
    rejectedVote: '坏人方破坏了投票',
  },
};
